export default __webpack_public_path__ + "static/norfolkcc-54da60f9099e44e48bfec037b0b3b058.png";